
import { Glide, GlideSlide } from 'vue-glide-js';
import 'vue-glide-js/dist/vue-glide.css';

export default {
  name: 'Uislider',

  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    mobilePerView: {
      type: Number,
      default: 1,
    },
    tabletPerView: {
      type: Number,
      default: 3,
    },
    desktopPerView: {
      type: Number,
      default: 4,
    },
    slideGap: {
      type: Number,
      default: 16,
    },
    startAt: {
      type: Number,
      default: 0,
    },
    padding: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      active: 0,
      mobile: 768,
      tablet: 1024,
      perView: 4,
      touchDistance: false,
      options: {
        perView: this.desktopPerView,
        gap: this.slideGap,
        startAt: 0,
        focusAt: 0,
        bound: true,
        swipeThreshold: 20,
        breakpoints: {
          1024: {
            perView: this.tabletPerView,
            focusAt: 0,
          },
          768: {
            perView: this.mobilePerView,
            focusAt: this.padding ? 0.05 : 0,
          },
        },
      },
      touch: {
        startX: null,
        currentX: null,
        startY: null,
        currentY: null,
      },
    };
  },

  computed: {
    pages() {
      const extra = Boolean(this.items.length % this.perView);
      const length = this.items.length / this.perView;
      return !extra
        ? this.items.slice(0, length)
        : this.items.slice(0, length + 1);
    },
    activePage() {
      if (this.active === 0) {
        return 0;
      } else if (this.active === this.items.length % this.perView) {
        return this.pages.length - 1;
      } else {
        return Math.floor(this.active / this.perView);
      }
    },
  },

  watch: {
    active(value) {
      if (value) {
        this.$emit('active', { perView: this.perView, active: value });
      }
    },
    startAt(value) {
      this.options.startAt = value;
      this.active = value;
    },
  },

  mounted() {
    if (this.startAt) {
      this.active = this.startAt;
    }
    if (window) {
      if (window.innerWidth > this.tablet) {
        this.perView = this.desktopPerView;
      } else {
        this.perView = this.tabletPerView;
      }
    }
  },

  methods: {
    moveToSlide(i) {
      this.active = i;
    },

    next() {
      if (
        this.activePage === this.pages.length - 2 &&
        this.items.length % this.perView !== 0
      ) {
        this.active += this.items.length % this.perView;
      } else {
        this.active = (this.activePage + 1) * this.perView;
      }
    },

    prev() {
      if (
        this.activePage === this.pages.length - 1 &&
        this.items.length % this.perView !== 0
      ) {
        this.active = this.active - (this.items.length % this.perView);
      } else {
        this.active = (this.activePage - 1) * this.perView;
      }
    },

    moveToPage(i) {
      if (
        i === this.pages.length - 1 &&
        this.items.length % this.perView !== 0
      ) {
        this.active =
          (i - 1) * this.perView + (this.items.length % this.perView);
      } else {
        this.active = i * this.perView;
      }
    },

    touchStart(e) {
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
    },

    touchMove(e) {
      this.currentX = e.touches[0].clientX;
      this.currentY = e.touches[0].clientY;
      const xDif = this.difference(this.startX, this.currentX);
      const yDif = this.difference(this.startY, this.currentY);
      if (xDif > yDif) {
        e.preventDefault();
      }
    },

    difference(a, b) {
      return Math.abs(a - b);
    },
  },
};
